<div class="modal-body">
  <p [innerHTML]="message | translate: messageParams"></p>
</div>
<div class="modal-footer">
  @if (btnCancelText.length > 0) {
    <button type="button" class="c-button c-button--secondary" (click)="decline()">{{ btnCancelText | translate }}</button>
  }
  <button type="button" class="c-button c-button--primary" (click)="accept()">{{ btnOkText | translate }}</button>
</div>

